export const SMART_PAGE_PATHS = {
  // Smart page
  SMART_PAGE_SIGNUP: 'SMART_PAGE_SIGNUP',
  SMART_PAGE_EDITOR: 'SMART_PAGE_EDITOR',
  SMART_PAGE_CUSTOM_DOMAIN: 'SMART_PAGE_CUSTOM_DOMAIN',
};

export const ONBOARDING_PATHS = {
  COLLECT_BUSINESS_INFO: 'COLLECT_BUSINESS_INFO',
  CAMPAIGN_CREATION_METHOD: 'CAMPAIGN_CREATION_METHOD',
  LANGUAGE_COUNTRY: 'LANGUAGE_COUNTRY',
  WEBSITE: 'WEBSITE',
  CAMPAIGN_MODE: 'CAMPAIGN_MODE',

  // Import
  GOOGLE_IMPORT: 'GOOGLE_IMPORT',
  FACEBOOK_IMPORT: 'FACEBOOK_IMPORT',

  ...SMART_PAGE_PATHS,
};

export const PREVIEW_TO_NON_PREVIEW_MAPPING = {
  PREVIEW_ASSETS: 'AD_ASSETS',
  PREVIEW_ACCOUNT: 'ACCOUNT_DETAILS',
  PREVIEW_PAYMENT: 'PAYMENT',
  PREVIEW_ADD_FUNDS: 'ADD_FUNDS',
};

export const NON_PREVIEW_TO_PREVIEW_MAPPING = {
  AD_ASSETS: 'PREVIEW_ASSETS',
  TARGETING: 'PREVIEW_ASSETS',
  BUDGET: 'PREVIEW_ASSETS',
  ACCOUNT_DETAILS: 'PREVIEW_ACCOUNT',
  PAYMENT: 'PREVIEW_PAYMENT',
  ADD_FUNDS: 'PREVIEW_ADD_FUNDS',
};

export const CAMPAIGN_CREATION_PATHS = {
  // PMAX campaign creation
  AD_ASSETS: 'AD_ASSETS',
  TARGETING: 'TARGETING',
  BUDGET: 'BUDGET',
  PREVIEW_ASSETS: 'PREVIEW_ASSETS',
};

export const PMAX_LITE_WIZARD_STEP_PATHS = {
  ...ONBOARDING_PATHS,
  ...CAMPAIGN_CREATION_PATHS,

  // Account and payment
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  PAYMENT: 'PAYMENT',
  ADD_FUNDS: 'ADD_FUNDS',

  PREVIEW_ACCOUNT: 'PREVIEW_ACCOUNT',
  PREVIEW_PAYMENT: 'PREVIEW_PAYMENT',
  PREVIEW_ADD_FUNDS: 'PREVIEW_ADD_FUNDS',

  CONVERSION_UPSELL: 'CONVERSION_UPSELL',
  IMPORT_COMPLETE: 'IMPORT_COMPLETE',
};

export const CARD_STYLE_PATHS = [
  ONBOARDING_PATHS.CAMPAIGN_CREATION_METHOD,
  ONBOARDING_PATHS.LANGUAGE_COUNTRY,
  ONBOARDING_PATHS.WEBSITE,
  ONBOARDING_PATHS.CAMPAIGN_MODE,
  ONBOARDING_PATHS.SMART_PAGE_SIGNUP,
];

export const stepToPage = {
  [PMAX_LITE_WIZARD_STEP_PATHS.COLLECT_BUSINESS_INFO]: 'pmaxlite010.collectBusinessInfo',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD]: 'pmaxlite010.creationMethod',
  // Start Import
  [PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT]: 'pmaxlite020.googleImport',
  [PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT]: 'pmaxlite020.facebookImport',
  // End Import
  [PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY]: 'pmaxlite020.languageCountry',
  [PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE]: 'pmaxlite030.website',
  // Start Smart Page
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP]: 'pmaxlite030.smartpage.signup',
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR]: 'pmaxlite030.smartpage.editor',
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN]: 'pmaxlite030.smartpage.customDomain',
  // End Smart Page
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE]: 'pmaxlite040.campaignMode',
  // Start PMax Campaign
  [PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS]: 'pmaxlite050.pmax.buildAds',
  [PMAX_LITE_WIZARD_STEP_PATHS.TARGETING]: 'pmaxlite050.pmax.targeting',
  [PMAX_LITE_WIZARD_STEP_PATHS.BUDGET]: 'pmaxlite050.pmax.budget',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS]: 'pmaxlite050.pmax.buildAds',
  // End PMax Campaign
  [PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS]: 'pmaxlite060.accountDetails',
  [PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT]: 'pmaxlite070.payment',
  [PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS]: 'pmaxlite075.paymentAddFunds',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT]: 'pmaxlite060.accountDetails',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT]: 'pmaxlite070.payment',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS]: 'pmaxlite075.paymentAddFunds',
  [PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL]: 'pmaxlite080.conversionUpsell',
  [PMAX_LITE_WIZARD_STEP_PATHS.IMPORT_COMPLETE]: 'pmaxlite085.importComplete',
};
